import { I18n } from "@aws-amplify/core";

export const createSiteDictionary = languages => {
  return languages.reduceRight((acc, curr) => {
    return Object.assign(acc, curr.dictionary);
  }, {});
};

export const setSiteDictionary = languages => {
  const languageId = languages[0].id;
  I18n.putVocabularies({ [languageId]: createSiteDictionary(languages) });
  I18n.setLanguage(languageId);
};
